import { type FunctionComponent } from 'react';
import { useStreetPageQuery } from '../../graphql/useStreetPageQuery';
import { StreetPageBanner } from './StreetPageBanner';
import { useFeatureRollout } from '@rea-argonaut/experiment';
import { StreetPageBannerTemporaryCampaign } from './StreetPageBannerTemporaryCampaign';

export const StreetPageBannerWithData: FunctionComponent = () => {
  const isTemporaryCampaign = useFeatureRollout(
    'media_partner_banner_temporary_campaign',
  ).isEnabled();

  const streetPageBySlug = useStreetPageQuery()?.data?.streetPageBySlug;

  if (isTemporaryCampaign) {
    const mediaPartnerBanner = streetPageBySlug?.mediaPartnerBannerTemporaryCampaign;

    if (!mediaPartnerBanner) return null;

    const { text, link, termsAndConditions, termsAndConditionsShort } = mediaPartnerBanner;
    const { variant, title, url, tracking } = link;

    const outboundTracking = tracking?.outboundTracking;
    if (!outboundTracking) return null;

    return (
      <StreetPageBannerTemporaryCampaign
        text={text}
        variant={variant}
        title={title}
        url={url}
        outboundTracking={outboundTracking}
        termsAndConditions={termsAndConditions}
        termsAndConditionsShort={termsAndConditionsShort}
      />
    );
  } else {
    const mediaPartnerBanner = streetPageBySlug?.mediaPartnerBanner;

    if (!mediaPartnerBanner) return null;

    const { text, link } = mediaPartnerBanner;
    const { variant, title, url, tracking } = link;

    const outboundTracking = tracking?.outboundTracking;
    if (!outboundTracking) return null;

    return (
      <StreetPageBanner
        text={text}
        variant={variant}
        title={title}
        url={url}
        outboundTracking={outboundTracking}
      />
    );
  }
};
